<template>
  <span
    class="account-avatar"
    aria-hidden="true"
  >
    <i
      :class="icon"
      class="fas"
    />
  </span>
</template>

<script>
export default {
  name: 'AccountAvatar',
  props: {
    icon: {
      type: String,
      default: 'fa-user-cog',
    },
  },
};
</script>

<style lang="scss" scoped>
.account-avatar {
  display: inline-flex;
  width: var(--avatar-size, #{$target-pointer});
  height: var(--avatar-size, #{$target-pointer});
  flex: none;
  border-radius: 50%;
  background-color: #333;

  align-items: center;
  justify-content: center;

  i {
    color: $color-primary;
    font-size: var(--avatar-icon, 1.125rem);
  }

  .fa-user-cog {
    margin-left: 2.5px;
  }
}
</style>
